import React, { createContext, useContext, useState, useEffect } from 'react';
import { addToHistory } from '../utils/history';

const StatusContext = createContext();

export const useStatus = () => {
  const context = useContext(StatusContext);
  if (!context) {
    throw new Error('useStatus must be used within a StatusProvider');
  }
  return context;
};

export const StatusProvider = ({ children }) => {
  const [currentResult, setCurrentResult] = useState(null);
  const [isChecking, setIsChecking] = useState(false);

  // Load settings from localStorage
  const [settings, setSettings] = useState(() => {
    try {
      const saved = localStorage.getItem('webdownstatus_settings');
      return saved ? JSON.parse(saved) : {
        protocol: 'https',
        timeoutMs: 10000,
        maxRedirects: 5,
        retries: 1,
        thresholdMs: 2000,
        enableDNS: true,
        useServer: true // New setting for server-side checks
      };
    } catch {
      return {
        protocol: 'https',
        timeoutMs: 10000,
        maxRedirects: 5,
        retries: 1,
        thresholdMs: 2000,
        enableDNS: true,
        useServer: true
      };
    }
  });

  // Save settings to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('webdownstatus_settings', JSON.stringify(settings));
  }, [settings]);

  const updateSettings = (newSettings) => {
    setSettings(prev => ({ ...prev, ...newSettings }));
  };

  const saveResult = (result) => {
    setCurrentResult(result);
    if (result && !result.error) {
      addToHistory(result);
    }
  };

  return (
    <StatusContext.Provider value={{
      currentResult,
      setCurrentResult: saveResult,
      isChecking,
      setIsChecking,
      settings,
      updateSettings
    }}>
      {children}
    </StatusContext.Provider>
  );
};